<template>
 <div class="tab-container" :style='{width: panelWidth}' >

    <!-- <el-tag>mounted times </el-tag>
    <el-alert :closable="false" style="width:200px;display:inline-block;vertical-align: middle;margin-left:30px;" title="Tab with keep-alive" type="success" /> -->
    <el-tabs v-model="activeName" type="border-card">

      <el-tab-pane v-for='item in panel.subMenu' :key='item.id' :name='item.id' :label='item.options.title' style='color: black;'>
        <keep-alive>
            <component ref="orderarray" :parentPanel='panel' :is='item.class' v-if="activeName==item.id" :data='inData[item.id]' :panel='item' @getDetail='getDetail'/>
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import OrderArray from './orderArray'
import MarginCallArray from './marginCallArray'
import monitoringMixin from './mixins'

export default {
  name: 'OrderTab',
  mixins: [ monitoringMixin ],
  components: { OrderArray, MarginCallArray },
  props: [ 'data', 'panel' ],
  data() {
    return {
      activeName: 'TopWorkingOrder'
    }
  },
  watch: {
    activeName(val) {
      //this.$router.push(`${this.$route.path}?tab=${val}`).catch(err => {})
      this.$router.push(`${this.$route.path}?tabOrder=${val}`).catch(() => {})
    }
  },
  created() {
    // init the default  selected tab
    const tab = this.$route.query.tabOrder
    if (tab) {
      this.activeName = tab
    }
  },
  computed: {
    inData: function () {
      return this.data ? this.data : {}
    }
  },
  methods: {
    getDetail: function (params) {
      this.$emit('getDetail', params)
    },
    onExportExcel: function (sheetOnly,exportExcel='',exportExcelFilePrefix='', panelId='') {
      if (sheetOnly) {
        return this.$refs.orderarray[0].onExportExcel(sheetOnly,exportExcel,exportExcelFilePrefix, panelId)
      } else {
        let selectedTab = this.panel.subMenu.find(item => item.id === this.activeName)
        if (selectedTab != null)
          return this.$refs.orderarray[0].onExportExcel(sheetOnly,selectedTab.exportExcel,selectedTab.exportExcelFilePrefix, selectedTab.id)
      }
    }
  }
}
</script>

<style>

</style>